import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import {
	ClipboardService,
	LinkingService,
	MediaLibraryService,
	NetworkService,
	NotificationService,
	runMigration,
	SentryService,
	SplashScreenService,
	UpdateService,
	ValidatorService,
} from 'src/data/services/Services';

const TAG = '[useServicesStore] ->';

export const useServicesStore = create(
	combine({}, (_set) => {
		const init = () => {
			console.info(TAG, 'init()');
			SentryService.init();
		};

		const checkForUpdates = async () => await UpdateService.checkForUpdate();
		const hideSplashScreen = async () => await SplashScreenService.hideAsync();
		const captureEvent = ({ message, extra }: { message: string; extra?: Record<string, unknown> }) =>
			SentryService.captureEvent({ message, extra });
		const initNotifications = async () => await NotificationService.init();
		const migrate = async () => await runMigration();

		const openUrlInternally = ({ url }: { url: string }) => LinkingService.openUrlInternally({ url });
		const openUrlExternally = ({ url }: { url: string }) => LinkingService.openUrlExternally({ url });
		const openEmail = ({ email }: { email: string }) => LinkingService.openEmail({ email });
		const openPhoneNumber = ({ phoneNumber }: { phoneNumber: string }) => LinkingService.openPhoneNumber({ phoneNumber });

		return {
			init,
			checkForUpdates,
			hideSplashScreen,
			captureEvent,
			initNotifications,
			migrate,
			openUrlInternally,
			openUrlExternally,
			openEmail,
			openPhoneNumber,
			validator: ValidatorService,
			clipboard: ClipboardService,
			network: NetworkService,
			// Saving a photo. Both platforms can: native writes to the gallery, a browser writes to
			// the downloads folder. A failure rejects, so callers handle that rather than ask first.
			mediaLibrary: MediaLibraryService,
		};
	}),
);
